/** Normaliseert een NL-telefoonnummer naar compact formaat zonder spaties/scheidingstekens.
 *  Leading +31 / 0031 wordt 0. Strip spaties, streepjes, haakjes, punten.
 *  Geeft de input compact terug; niet-herkenbaar/leeg blijft ongewijzigd (geen gok). */
export function formatNlTelefoon(input: string | null | undefined): string {
  if (!input) return ''
  let s = input.replace(/[\s\-()./]/g, '')
  if (s.startsWith('0031')) s = '0' + s.slice(4)
  else if (s.startsWith('+31')) s = '0' + s.slice(3)
  return s
}
